import { CheckoutConfirmationConfig } from "@ui/context/component-config-context";

const checkoutConfirmationConfig: CheckoutConfirmationConfig = {
  titleRecurring: "Thanks for <br /> becoming a member!",
  titleOneTime: "Thanks for <br /> your support!",
  includeCaptcha: false,
  descriptionOneTime:
    "Your contribution helps support our journalism and you now have access to all our Member-only content, <em>The Highlight</em>, bonus content and more.",
  descriptionRecurring:
    "You now have unlimited access to all things Vox. To set up ad-free listening for your favorite Vox podcasts, head to <a href='/account/podcasts'>your account</a> page to get set-up.",
};

export default checkoutConfirmationConfig;
